import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/translation-memory/layout.tsx")